<template>
    <v-radio-group
        v-model="selected"
        v-bind="$attrs"
        v-on="$listeners"
        :hide-details="!hasErrors"
        :error-messages="hasErrors ? errors.list(errorName) : []"
        @change="errors && errors.remove(errorName)"
    >
        <template v-if="label" #label>
            <div><strong>{{ label }}</strong></div>
        </template>

        <v-radio
            v-for="item in items"
            :key="item.value"
            :label="item.label"
            :value="item.value"
            :ripple="false"
        />
    </v-radio-group>
</template>

<script>
export default {
    props: {
        value: {},
        label: String,
        errors: Object,
        errorName: String,
        items: Array,
    },
    computed: {
        selected: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            },
        },
        hasErrors() {
            return this.errors && this.errors.has(this.errorName);
        },
    },
}
</script>
